<template>
	<div class="login">
		<div class="main">
			<transition name="van-fade" mode="out-in">
				<LoginMobile v-if="curActive === 'LoginMobile'" @sendSmsCode="sendSmsCode" />
				<LoginCode :mobile="mobile" v-if="curActive === 'LoginCode'" />
			</transition>
		</div>
	</div>
</template>

<script>
	import LoginMobile from './components/login-mobile.vue'
	import LoginCode from './components/login-code.vue'
	export default {
		name: 'login',
		components: { LoginMobile, LoginCode },
		data: () => ({
			curActive: 'LoginMobile',
			mobile: ''
		}),
		methods: {
			// 发送手机验证码
			sendSmsCode (data) {
				if (data && data.mobile) {
					this.mobile = data.mobile
					this.curActive = 'LoginCode'
				}
			}
		}
	}
</script>

<style scoped>
	.login {
		min-height: 100vh;
		background-color: #fff;
	}
</style>
